const getColor = (status) => {
    switch (status) {
        case 'active':
            return 'var(--main_purple)';
        case 'inactive':
            return 'var(--gray_purple_middle)';
        case 'success':
            return 'var(--green)';
        case 'error':
            return 'var(--red)';
        case 'no-info':
            return 'var(--gray-dark)';
        case 'loading':
            return 'var(--main_purple_light)';
        default:
            return 'var(--gray_purple_middle)';
    }
};

export default getColor;
